export default __webpack_public_path__ + "locales/pt-BR/DeleteThirdPartyDialog.json?hash=1a6ba3d2c36b7b5cb0ba1d0ea006f06a";